module.exports = __webpack_public_path__ + "static/img/bg-head.37ef0c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-head.png
// module id = Xhnj
// module chunks = 12